(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header')
			this.headerWrapper = document.querySelector('.header-wrapper')
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always'
			this.headerBounds = {}
			this.currentScrollTop = 0
			this.preventReveal = false
			this.predictiveSearch = this.querySelector('predictive-search')

			this.onScrollHandler = this.onScroll.bind(this)
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.addEventListener('scroll', this.onScrollHandler, false)

			this.createObserver()
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.removeEventListener('scroll', this.onScrollHandler)
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect
				observer.disconnect()
			})

			if (this.header) {
				observer.observe(this.header)
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add(
					'shopify-section-header-sticky',
					'shopify-section-header-always-sticky',
				)
				this.header.classList.remove('color-background-3')
				this.header.style.transition =
					'background var(--duration-short), transform var(--duration-default)'
			}

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky')
				this.header.style.transition = 'background var(--duration-short)'
				if (this.header.classList.contains('color-background-1')) {
					this.header.classList.add('color-background-3')
				}
			}

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.preventHide) return
				requestAnimationFrame(this.hide.bind(this))
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this))
				} else {
					window.clearTimeout(this.isScrolling)

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false
					}, 66)

					requestAnimationFrame(this.hide.bind(this))
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this))
			}

			this.currentScrollTop = scrollTop
		}

		hide() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
			this.closeMenuDisclosure()
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-sticky', 'animate')
			this.header.classList.remove('shopify-section-header-hidden', 'color-background-3')
		}

		reset() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate',
			)
			if (this.header.classList.contains('color-background-1')) {
				this.header.classList.add('color-background-3')
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure')
			if (this.disclosures) {
				this.disclosures.forEach((disclosure) => {
					disclosure.close()
				})
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list')
			if (this.disclosureLists) {
				this.disclosureLists.forEach((disclosureList) => {
					disclosureList.setAttribute('hidden', true)
				})
			}
		}
	}

	customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suri-bracelet-stacking-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeBraceletGuide = (root) => {
      if (!root || root.dataset.braceletReady === 'true') return;
      root.dataset.braceletReady = 'true';
      const stages = ['foundation', 'texture', 'light'];
      const choices = Object.fromEntries(stages.map((stage) => [stage, Array.from(root.querySelectorAll(`[data-bsg-choice][data-bsg-stage="${stage}"]`))]));
      const selections = {};
      const selectChoice = (stage, choice) => {
        if (!choice) return;
        choices[stage].forEach((item) => { const selected = item === choice; item.classList.toggle('is-selected', selected); item.setAttribute('aria-pressed', String(selected)); });
        selections[stage] = choice;
        const slot = root.querySelector(`[data-bsg-slot="${stage}"]`);
        if (slot) {
          slot.href = choice.dataset.productUrl;
          const image = slot.querySelector('.bsg-equation__image img');
          if (image && choice.dataset.productImage) {
            image.src = choice.dataset.productImage;
            image.srcset = '';
            image.alt = choice.dataset.productTitle;
          }
        }
      };
      stages.forEach((stage) => selectChoice(stage, choices[stage].find((item) => item.classList.contains('is-selected')) || choices[stage][0]));
      root.querySelectorAll('[data-bsg-choice]').forEach((choice) => {
        choice.addEventListener('click', () => {
          const stage = choice.dataset.bsgStage;
          const index = Number(choice.dataset.bsgIndex || 0);
          selectChoice(stage, choice);
          if (stage === 'foundation') { selectChoice('texture', choices.texture[index] || choices.texture[0]); selectChoice('light', choices.light[index] || choices.light[0]); }
          const status = root.querySelector('[data-bsg-status]'); if (status) status.textContent = '';
        });
      });
      root.querySelector('[data-bsg-reset]')?.addEventListener('click', (event) => {
        selectChoice('foundation', choices.foundation[0]); selectChoice('texture', choices.texture[0]); selectChoice('light', choices.light[0]);
        event.currentTarget.animate([{ transform:'rotate(0)' }, { transform:'rotate(-360deg)' }], { duration:450, easing:'ease-out' });
        const status = root.querySelector('[data-bsg-status]'); if (status) status.textContent = 'Bracelet stack reset.';
      });

    };
    document.querySelectorAll('[data-suri-bracelet-guide]').forEach(initializeBraceletGuide);
    document.addEventListener('shopify:section:load', (event) => initializeBraceletGuide(event.target.querySelector('[data-suri-bracelet-guide]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suri-kinetic-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeKinetic = (root) => {
      if (!root || root.dataset.kineticReady === 'true') return;
      root.dataset.kineticReady = 'true';

      const revealItems = root.querySelectorAll('[data-ki-reveal]');
      if (!('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12 }
      );

      revealItems.forEach((item) => observer.observe(item));
    };

    document.querySelectorAll('[data-suri-kinetic]').forEach(initializeKinetic);
    document.addEventListener('shopify:section:load', (event) => {
      initializeKinetic(event.target.querySelector('[data-suri-kinetic]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suri-kinetic-stacking-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeStackingGuide = (root) => {
      if (!root || root.dataset.stackingReady === 'true') return;
      root.dataset.stackingReady = 'true';

      const editorialTabs = Array.from(root.querySelectorAll('[data-rsg-editorial-tab]'));
      const editorialPanels = Array.from(root.querySelectorAll('[data-rsg-editorial-panel]'));

      editorialTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.rsgEditorialTab;
          editorialTabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
          editorialPanels.forEach((panel) => {
            const active = panel.dataset.rsgEditorialPanel === target;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          });
        });
      });

      const stageOrder = ['anchor', 'contrast', 'light'];
      const steps = Array.from(root.querySelectorAll('[data-rsg-step]'));
      const choicesByStage = Object.fromEntries(
        stageOrder.map((stage) => [stage, Array.from(root.querySelectorAll(`[data-rsg-choice][data-rsg-stage="${stage}"]`))])
      );
      const selections = {};

      const openStep = (stage) => {
        steps.forEach((step) => {
          const ownsStage = Boolean(step.querySelector(`[data-rsg-choice][data-rsg-stage="${stage}"]`));
          step.classList.toggle('is-open', ownsStage);
          step.querySelector('[data-rsg-step-toggle]').setAttribute('aria-expanded', String(ownsStage));
          step.querySelector('.rsg-step__content').hidden = !ownsStage;
        });
      };

      const applyChoice = (stage, choice) => {
        if (!choice) return;
        choicesByStage[stage].forEach((item) => {
          const selected = item === choice;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        selections[stage] = choice;

        const slot = root.querySelector(`[data-rsg-slot="${stage}"]`);
        const link = slot?.querySelector('[data-rsg-slot-link]');
        const image = slot?.querySelector('img');
        if (link) {
          link.href = choice.dataset.productUrl;
          link.setAttribute('aria-label', `View ${choice.dataset.productTitle}`);
        }
        if (image && choice.dataset.productImage) {
          image.src = choice.dataset.productImage;
          image.srcset = '';
          image.alt = choice.dataset.productTitle;
        }
      };

      stageOrder.forEach((stage) => {
        const initial = choicesByStage[stage].find((choice) => choice.classList.contains('is-selected')) || choicesByStage[stage][0];
        applyChoice(stage, initial);
      });

      root.querySelectorAll('[data-rsg-step-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const step = toggle.closest('[data-rsg-step]');
          const content = step.querySelector('.rsg-step__content');
          const opening = !step.classList.contains('is-open');

          root.querySelectorAll('[data-rsg-step]').forEach((item) => {
            item.classList.remove('is-open');
            item.querySelector('[data-rsg-step-toggle]').setAttribute('aria-expanded', 'false');
            item.querySelector('.rsg-step__content').hidden = true;
          });

          if (opening) {
            step.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            content.hidden = false;
          }
        });
      });

      root.querySelectorAll('[data-rsg-choice]').forEach((choice) => {
        choice.addEventListener('click', () => {
          const stage = choice.dataset.rsgStage;
          const index = Number(choice.dataset.rsgIndex || 0);
          applyChoice(stage, choice);

          if (stage === 'anchor') {
            applyChoice('contrast', choicesByStage.contrast[index] || choicesByStage.contrast[0]);
            applyChoice('light', choicesByStage.light[index] || choicesByStage.light[0]);
            openStep('contrast');
          } else if (stage === 'contrast') {
            applyChoice('light', choicesByStage.light[index] || choicesByStage.light[0]);
            openStep('light');
          }

          const status = root.querySelector('[data-rsg-status]');
          if (status) status.textContent = '';
        });
      });

      root.querySelector('[data-rsg-reset]')?.addEventListener('click', (event) => {
        const button = event.currentTarget;
        stageOrder.forEach((stage) => applyChoice(stage, choicesByStage[stage][1] || choicesByStage[stage][0]));
        openStep('anchor');
        const status = root.querySelector('[data-rsg-status]');
        if (status) status.textContent = 'Stack reset to the balanced formula.';
        button.animate([{ transform: 'rotate(0)' }, { transform: 'rotate(-360deg)' }], { duration: 450, easing: 'ease-out' });
      });


    };

    document.querySelectorAll('[data-suri-stacking-guide]').forEach(initializeStackingGuide);
    document.addEventListener('shopify:section:load', (event) => {
      initializeStackingGuide(event.target.querySelector('[data-suri-stacking-guide]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suri-objects-in-motion"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=(root)=>{if(!root||root.dataset.ready)return;root.dataset.ready='1';const track=root.querySelector('[data-motion-track]');const step=()=>Math.max(280,track.clientWidth*.72);root.querySelector('[data-motion-prev]')?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));root.querySelector('[data-motion-next]')?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));};document.querySelectorAll('[data-suri-motion]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-suri-motion]')));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suri-stacking-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-suri-stacking-collection]').forEach((root) => {
      const sort = root.querySelector('[data-ssc-sort]');
      if (!sort || sort.dataset.ready === 'true') return;
      sort.dataset.ready = 'true';
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        url.searchParams.set('sort_by', sort.value);
        window.location.assign(url.toString());
      });
      let selectedStackProducts = [];
      const anatomy = root.querySelector('[data-ssc-anatomy]');
      if (anatomy) {
        const triggers = Array.from(anatomy.querySelectorAll('[data-ssc-anatomy-trigger]'));
        const pieces = Array.from(anatomy.querySelectorAll('[data-ssc-anatomy-piece]'));
        triggers.forEach((trigger) => trigger.addEventListener('click', () => {
          const index = trigger.dataset.sscAnatomyTrigger;
          triggers.forEach((item) => {
            const active = item === trigger;
            item.setAttribute('aria-pressed', String(active));
            item.closest('li')?.classList.toggle('is-active', active);
          });
          pieces.forEach((piece) => piece.classList.toggle('is-active', piece.dataset.sscAnatomyPiece === index));
        }));
        const choices = Array.from(anatomy.querySelectorAll('[data-ssc-ear-choice], [data-ssc-neck-choice]'));
        if (choices.length) {
          const readChoice = (choice) => {
            try { return JSON.parse(choice.querySelector('[data-ssc-choice-product]')?.textContent || '{}'); }
            catch (error) { return {}; }
          };
          const syncSelection = () => {
            selectedStackProducts = [0, 1, 2].map((slot) => {
              const choice = choices.find((item) => Number(item.dataset.slot) === slot && item.classList.contains('is-selected'));
              return choice ? readChoice(choice) : null;
            }).filter(Boolean);
            root.dispatchEvent(new CustomEvent('ssc:stack-change', { detail:{ products:selectedStackProducts } }));
          };
          choices.forEach((choice) => choice.addEventListener('click', () => {
            const slot = Number(choice.dataset.slot);
            choices.filter((item) => Number(item.dataset.slot) === slot).forEach((item) => {
              const selected = item === choice;
              item.classList.toggle('is-selected', selected);
              item.setAttribute('aria-pressed', String(selected));
            });
            const product = readChoice(choice);
            const piece = pieces[slot];
            if (piece && product.title) {
              piece.href = product.url;
              piece.setAttribute('aria-label', `View ${product.title}`);
              const image = piece.querySelector('img');
              if (image && product.image) {
                image.src = product.image;
                image.srcset = '';
                image.alt = product.title;
              }
            }
            const stage = choice.closest('[data-ssc-ear-stage], [data-ssc-neck-stage]');
            const name = stage?.querySelector('[data-ssc-selected-name]');
            if (name) name.textContent = product.title;
            stage?.querySelector('[data-ssc-anatomy-trigger]')?.click();
            syncSelection();
          }));
          selectedStackProducts = [0, 1, 2].map((slot) => readChoice(choices.find((item) => Number(item.dataset.slot) === slot && item.classList.contains('is-selected')))).filter((product) => product.title);
        }
      }

    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suri-trending-collection"] && !Shopify.designMode) return;
  try {
    (()=>{const init=r=>{if(!r||r.dataset.ready)return;r.dataset.ready='1';const tabs=[...r.querySelectorAll('[data-tab]')],panels=[...r.querySelectorAll('[data-panel]')];tabs.forEach(t=>t.addEventListener('click',()=>{tabs.forEach(x=>x.setAttribute('aria-selected',String(x===t)));panels.forEach(p=>p.hidden=p.dataset.panel!==t.dataset.tab)}))};document.querySelectorAll('[data-trending-page]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-trending-page]')));})();
  } catch(e) { console.error(e); }
})();
})();
